export enum BldConditionTypeEnum {
  "建築条件あり" = "建築条件あり",
  "建築条件なし" = "建築条件なし"
}
